import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
})
export class HelpComponent  {

  rebook : boolean;
  pay: boolean;
  loader:boolean = false;


  constructor() { }


}
